<!-- 个人设置 -->
<template>
  <div class="basicStyle">
    <div class="infoBox">
      <h1 class="title">基本信息</h1>
      <div class="item">
        <div class="left">用户名：</div>
        <div class="right">{{ userInfo.username }}</div>
      </div>
      <div class="item">
        <div class="left">
          {{ userInfo.role == "admin" ? "机构名字：" : "真实姓名：" }}
        </div>
        <div class="right">
          {{
            userInfo.role == "admin" ? userInfo.group.name : userInfo.realname
          }}
        </div>
      </div>
      <div
        v-if="userInfo.role == 'admin' && userInfo.group.admin_realname"
        class="item"
      >
        <div class="left">真实姓名：</div>
        <div class="right">{{ userInfo.group.admin_realname }}</div>
      </div>
      <div class="item">
        <div class="left">角色：</div>
        <div class="right">{{ userInfo.role_name }}</div>
      </div>
      <div class="item">
        <div class="left">登录手机号码：</div>
        <div class="right">
          <!-- userInfo.role == "admin" ? userInfo.group.mobile : userInfo.mobile -->
          {{ userInfo.mobile }}
          <span class="xg_btn" @click="xgClick(userInfo.role)">修改</span>
        </div>
      </div>
    </div>
    <div class="infoBox codeStyle">
      <h1 class="title">密码管理</h1>
      <el-form
        :model="codeInfo"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="原始密码：" prop="password">
          <el-input
            v-model="codeInfo.password"
            placeholder="请输入原始密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="new_password">
          <el-input
            v-model="codeInfo.new_password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="new_password_confirmation">
          <el-input
            v-model="codeInfo.new_password_confirmation"
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="skip(1, 'ruleForm')"
            >确认修改</el-button
          >
          <el-button @click="skip(0, 'ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog
      title="修改登录手机号码"
      :visible.sync="modifyShow"
      class="formDialog"
      width="500px"
    >
      <el-form :model="modifyInfo" ref="modifyInfoForm" label-width="100px">
        <el-form-item label="当前手机号：" prop="oldMobile">
          {{ modifyInfo.oldMobile }}
        </el-form-item>
        <el-form-item label="新手机号：" prop="mobile">
          <el-input
            v-model="modifyInfo.mobile"
            placeholder=""
            size="mini"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="code">
          <el-input
            v-model="modifyInfo.code"
            placeholder=""
            size="mini"
            style="width: 246px"
            clearable
          ></el-input>
          <!-- 获取验证码 -->
          <!-- <MyButton :value="codeText" type="2" @click="getCode"></MyButton> -->
          <span class="code_bt" @click="getCode">{{ codeText }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="modifyInfoClick('modifyInfoForm')"
          size="medium"
          >确 定</el-button
        >
        <el-button @click="modifyShow = false" size="medium">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="安全验证"
        :visible.sync="vertifyDialog"
        class="formDialog"
        width="500px"
    >
      <el-form :model="modifyInfo" ref="modifyInfoForm" label-width="100px">
        <el-form-item label="" prop="oldMobile">
          <div style="display: flex; flex-direction: row;">
            <div style="display: flex; flex-direction: column;">
              <el-image style="margin-right: 20px;" :src="vertifyImg"></el-image>
              <span @click="refreshVertifyImg">点击刷新</span>
            </div>

            <el-input v-model="vertifyCode" placeholder="请输入左侧计算值"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
            type="primary"
            @click="sendSmsCode()"
            size="medium"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userApi from "@/api/user.js";
import commonApi from "@/api/common";
// import MyButton from "@/components/MyButton.vue";
import console from "console";
export default {
  name: "personalSettings",
  components: {
    // MyButton,
  },
  data() {
    return {
      codeInfo: {
        password: "",
        new_password: "",
        new_password_confirmation: "",
      },
      rules: {
        password: [
          { required: true, message: "请输入原始密码", trigger: "blur" },
        ],
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        new_password_confirmation: [
          { required: true, message: "请重新输入新密码", trigger: "blur" },
        ],
      },
      modifyShow: false,
      modifyInfo: {},
      codeText: "获取验证码",
      codeTime: 60,
      interval: null,
      userInfo: {},
      vertifyDialog: false,
      vertifyCode: '',
      vertifyImg: ''
    };
  },
  computed: {
    // userInfo() {
    //   return this.$store.state.user.userInfo;
    // },
  },
  created() {
    // Object.assign(
    //   this.userInfo,
    //   JSON.parse(sessionStorage.getItem("userInfo"))
    // );
    //  this.userInfo);
    this.getMe();
  },
  methods: {
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.userInfo = res.data;
        this.$forceUpdate();
        console.log("getMe", res.data);
      }
    },
    cdTime() {
      this.codeTime = 60;
      this.interval = setInterval(() => {
        this.codeTime--;
        this.codeText = this.codeTime + "秒后重试";
        if (this.codeTime <= 0) {
          this.codeText = "获取验证码";
          this.codeTime = 60;
          clearInterval(this.interval);
          return;
        }
      }, 1000);
    },
    async getCode() {
      // 获取验证码
      if (this.codeTime >= 60) {
        console.log("getCode", this.modifyInfo);
        if (!this.modifyInfo.mobile) {
          this.$message.error("输入新手机号！");
          return;
        }
        await this.getVertifyImg()
        // const res = await userApi.getSmsSend({
        //   mobile: this.modifyInfo.mobile,
        // });
        // if (res.code == 200) {
        //   this.cdTime();
        //   this.$message({
        //     message: "短信验证码已发送",
        //     type: "success",
        //   });
        // } else {
        //   this.$message.error(res.message);
        // }
      }
    },

    async sendSmsCode() {
      if (!this.vertifyCode) {
        this.$message.error("请输入右侧计算值");
        return;
      }
      const res = await userApi.getSmsSend({
        mobile: this.modifyInfo.mobile,
        captcha: this.vertifyCode,
      });
      if (res.Status === 200) {
        this.cdTime();
        this.$message({
          message: "短信验证码已发送",
          type: "success",
        });
        this.vertifyDialog = false
      } else {
        this.$message.error(res.ErrorMsg);
      }
    },
    // 刷新安全码
    async refreshVertifyImg() {
      const res = await commonApi.getVertifyCode({ mobile: this.modifyInfo.mobile })
      if (res.code === 200) {
        this.vertifyImg = res.data.img
      }
    },
    async getVertifyImg() {
      this.vertifyDialog = true
      const res = await commonApi.getVertifyCode({ mobile: this.modifyInfo.mobile })
      if (res.code === 200) {
        this.vertifyImg = res.data.img
      }
    },
    async modifyInfoClick() {
      const res = await commonApi.tobMobile({
        mobile: this.modifyInfo.mobile,
        code: this.modifyInfo.code,
      });
      if (res.code == 200) {
        this.getMe();
        this.$message.success(res.message);
        this.modifyShow = false;
      } else {
        this.$message.error(res.message);
      }
    },
    xgClick() {
      this.modifyInfo = {};
      // 手机号修改
      this.modifyInfo.oldMobile = this.userInfo.mobile;
      this.codeText = "获取验证码";
      this.codeTime = 60;
      clearInterval(this.interval);
      this.modifyShow = true;
    },
    skip(_type, formName) {
      if (_type) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            commonApi.editPassword(this.codeInfo).then((res) => {
              if (res.code == 200) {
                this.$message.success(res.message);
                this.$store.commit("delete_tabs", this.$route.path);
                this.$router.go(-1);
              } else {
                this.$message.error(res.message);
              }
            });
          }
        });
      } else {
        this.$router.go(-1);
        this.$store.commit("delete_tabs", this.$route.path);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  .infoBox {
    padding: 20px;
    border: 1px solid #ccc;
    width: 500px;
    border-radius: 10px;
    background-color: #fff;
    h1 {
      margin-bottom: 10px;
    }
    .item {
      display: flex;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #606266;
      .left {
        width: 120px;
        text-align: right;
        padding-right: 12px;
        box-sizing: border-box;
      }
      .right {
        flex: 1;
      }
    }
  }
  .infoBox + .infoBox {
    margin-top: 20px;
  }
  .codeStyle {
    /deep/ .el-input {
      width: 300px;
    }
    /deep/ .el-button + .el-button {
      margin-left: 30px;
    }
    /deep/ .el-button {
      width: 100px;
    }
    .codeBtn {
      margin-top: 30px;
    }
  }
}
.xg_btn {
  color: #846ffd;
  vertical-align: middle;
  margin-top: -5px;
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}
.xg_btn:hover {
  color: red;
}
/deep/.el-input__inner {
  font-size: 14px !important;
}
.code_bt {
  width: 110px;
  height: 42px;
  border: 1px solid #9583ff;
  display: inline-block;
  text-align: center;
  line-height: 42px;
  color: #9583ff;
  cursor: pointer;
}
.code_bt:hover {
  background-color: #9583ff;
  color: #fff;
}
</style>
